import { getOrCreateAnonymousSession } from "@/lib/anonymousSession";
import type { Document } from "../../types";

export interface CreateDocumentOptions {
  title?: string;
  isTemporary?: boolean;
}

type CreateDocumentParams = {
  titleOrOptions?: string | CreateDocumentOptions;
};

/**
 * Create a new document
 * For unauthenticated users, creates a temporary document that expires in 1 hour
 */
export async function createDocument({ titleOrOptions }: CreateDocumentParams): Promise<Document> {
  try {
    // Parse options
    let options: CreateDocumentOptions;
    if (typeof titleOrOptions === "string") {
      options = { title: titleOrOptions };
    } else {
      options = titleOrOptions || {};
    }

    const { title = "New Document", isTemporary = false } = options;

    // For temporary documents, get or create anonymous session
    const requestBody: any = { title };
    const headers: HeadersInit = { "Content-Type": "application/json" };

    if (isTemporary) {
      const session = getOrCreateAnonymousSession();
      requestBody.isTemporary = true;
      requestBody.anonymousSessionId = session.sessionId;
      headers["x-anonymous-session-id"] = session.sessionId;
      console.log(`📝 Creating temporary document with session: ${session.sessionId}`);
    }

    console.log("requestBody", requestBody);
    const response = await fetch(`/api/documents/create`, {
      method: "POST",
      headers,
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Authentication required to create documents");
      }
      throw new Error(`Failed to create document: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to create document:", error);
    throw error;
  }
}
